/**
 * Native iOS/Android shell transport (WKWebView message handler).
 * Desktop continues to use WebSocket to rig-bridge on localhost.
 */

const NATIVE_EVENT = 'cqRushRigMessage';

let nativeListenerInstalled = false;
let nativeMessageHandler = null;

function ensureNativeListener() {
  if (nativeListenerInstalled) {
    return;
  }
  nativeListenerInstalled = true;

  window.__cqRushRigBridge = {
    onMessage(payload) {
      if (typeof nativeMessageHandler === 'function') {
        nativeMessageHandler(payload);
      }
    }
  };

  window.addEventListener(NATIVE_EVENT, (event) => {
    if (typeof nativeMessageHandler === 'function') {
      nativeMessageHandler(event.detail);
    }
  });
}

export function isNativeRigBridgeAvailable() {
  return Boolean(
    window.__cqRushNativeRigBridge
    && typeof window.__cqRushNativeRigBridge.postMessage === 'function'
  );
}

export function createNativeRigBridgeTransport({ onMessage, onOpen, onClose, onError }) {
  ensureNativeListener();

  nativeMessageHandler = (payload) => {
    let message = payload;
    if (typeof payload === 'string') {
      try {
        message = JSON.parse(payload);
      } catch {
        return;
      }
    }

    if (message.type === 'bridge_open') {
      onOpen?.();
      return;
    }
    if (message.type === 'bridge_close') {
      onClose?.();
      return;
    }
    if (message.type === 'bridge_error') {
      onError?.(new Error(message.error || 'Native rig bridge error'));
      return;
    }

    onMessage?.({ data: JSON.stringify(message) });
  };

  return {
    open() {
      window.__cqRushNativeRigBridge.postMessage(JSON.stringify({ type: 'connect' }));
    },
    send(data) {
      window.__cqRushNativeRigBridge.postMessage(data);
    },
    close() {
      window.__cqRushNativeRigBridge.postMessage(JSON.stringify({ type: 'disconnect' }));
      nativeMessageHandler = null;
    },
    get readyState() {
      return 1;
    }
  };
}

export function markNativeRigBridgeInstalled() {
  if (!window.__cqRushNativeRigBridge) {
    window.__cqRushNativeRigBridge = {
      postMessage(message) {
        console.warn('CQ Rush native bridge not wired yet', message);
      }
    };
  }
}
